import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { useRouter } from 'next/router';
import { type FC, type ReactNode, useEffect, useState } from 'react';
import { useLoggedIn } from '@/Module/Auth/Hook';
import { GROWTH_BOOK_API_HOST, GROWTH_BOOK_CLIENT_KEY, GROWTH_BOOK_DECRYPTION_KEY } from '@/Module/Core/Constant';
import { getOrCreateAnonymousId } from '@/Module/Core/Helper';
import { useAppSelector } from '@/Module/Store/Hook';
const growthBook = new GrowthBook({
  apiHost: GROWTH_BOOK_API_HOST,
  clientKey: GROWTH_BOOK_CLIENT_KEY,
  decryptionKey: GROWTH_BOOK_DECRYPTION_KEY,
  enableDevMode: true
  // TODO: Use your real analytics tracking system
  // trackingCallback: (experiment, result) => {
  // Send logs to Sentry
  // Sentry.addBreadcrumb({
  //   category: 'experiment',
  //   message: 'Viewed Experiment (addBreadcrumb)',
  //   data: {
  //     experimentId: experiment.key,
  //     variationId: result.key,
  //   },
  //   level: 'info',
  // });

  // Capture a separate event
  // Sentry.captureEvent({
  //   message: 'Experiment Viewed (captureEvent)',
  //   level: 'info',
  //   extra: {
  //     experimentId: experiment.key,
  //     variationId: result.key,
  //   },
  // });
  // },
});
growthBook.init({
  streaming: true
});
interface GrowthBookWrapperProps {
  children: ReactNode;
}
const GrowthBookWrapper: FC<GrowthBookWrapperProps> = ({
  children
}) => {
  const router = useRouter();
  const isLoggedIn = useLoggedIn();
  const [isClient, setIsClient] = useState(false);
  const [anonymousId, setAnonymousId] = useState<string>('');
  const userId = useAppSelector(state => state.auth.person?.userId);
  useEffect(() => {
    setIsClient(true);
    setAnonymousId(getOrCreateAnonymousId());
  }, []);
  useEffect(() => {
    if (isClient) {
      growthBook.setURL(window.location.href);
      growthBook.setAttributes({
        id: userId || anonymousId,
        loggedIn: isLoggedIn,
        company: 'Ino',
        country: 'IR',
        browser: navigator.userAgent,
        url: router.pathname
      });
    }
  }, [router.pathname, isClient, userId, anonymousId, isLoggedIn]);
  return <GrowthBookProvider growthbook={growthBook} data-sentry-element="GrowthBookProvider" data-sentry-component="GrowthBookWrapper" data-sentry-source-file="GrowthBookWrapper.tsx">{children}</GrowthBookProvider>;
};
export default GrowthBookWrapper;